import { Col, Row } from 'antd'
import { Card, Icon, LoadingSpinner, Modal, ButtonGroup, Tooltip } from 'pepsico-ds'
import React, { useEffect, useState, useRef } from 'react'
import ModalFilters from './ModalFilters';
import CoManChart from '../Charts/ComanChart/CoManChart';
import ProgressBarChart from '../Charts/ProgressBarChart/ProgressBarChart';
import CustomLineChart from '../Charts/ComanChart/CustomLineChart';
import MultiSelectDropdown from '../Dropdown/MultiSelectDropdown';
import { CoManData } from '../../mocks/comanChartData'
import { splitNumericValue, handleDomToImgDownloadPdf } from "../../utils/utils"
import { useDispatch, useSelector } from "react-redux";
import { FetchSupplierPerfDetail } from "../../redux/action/SupplierPerfAction"
import Legend from '../Charts/Legend/Legend'
import NoData from '../NoData/NoData'
import { formatNumberWithCommas, splitValueWithUnit, returnHyphenIfNull } from '../../utils/utils'
import InfoIcon from '../Icons/InfoIcon';
import { localStoreKeys } from '../../constants/localStoreKeys';
import { trackModalView, getModalAttributes } from '../../utils/fullstory-utils';
import CustomButtons from '../Cards/CustomButtons';
import DropdownWithIcons from './DropdownWithIcons';
import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'
import LegendList from '../Charts/Legend/LegendList';
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';

// // const currentSpendActual = splitNumericValue(CoManData.spendActualData.spendActualForCurrentYear);
// const previousSpendActual = CoManData.spendActualData.spendActualForLastYear;
// const spendActualPrctChange = CoManData.spendActualData.percentage;
// // const productivityActual = splitNumericValue(CoManData.productivityActualData);
// const capacityUtilization = CoManData.capacityUtilizationActualData;
// const volumeActual = CoManData.volumeActualData;
// const cpmActualData = CoManData.cpmActualData;
// const spendVsAOPData = CoManData.spendActualVsAOPData;
// const productivityVsAOPData = CoManData.productivityActualVsAOPData;

// const capacityVsAOPData = CoManData.capacityActualVsAOPData;
// const volumeVsAOPData = CoManData.volumeActualVsAOPData;
// const cpmVsAOPData = CoManData.cpmActualVsAOPData;

function ComanModal({ openModal, setOpenModal, userData, selectedYear, capability, userDataLandingPage, landingPageFilters }) {
    
    const comanRef = useRef()
    const spendActualvsAOPChartRef = useRef()
    const productivityActualvsAOPChartRef = useRef()
    const volumeActualvsAOPChartRef = useRef()
    const complaintsActualvsAOPChartRef = useRef()

    const [supplierPerfData, setSupplierPerfData] = useState(null)
    const [loader, setLoader] = useState(false)
    const [monthDiff, setMonthDiff] = useState(0)
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const dispatch = useDispatch();
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
    const isLoading = useSelector((state) => state?.loader?.isLoading);
    // useEffect(() => {
    //     const postData = {
    //         "sector": [
    //             "AMESA"
    //         ],
    //         "bu": [
    //             "India"
    //         ],
    //         "l0":[
    //             "Co Man"
    //         ],
    //         "fromDate": "2024-06-01",
    //         "toDate": "2024-12-31"
    //     }
    //     dispatch(FetchSupplierPerfDetail(postData))
    // },
    //     [])

    // const supplierPerfAPIResponse = useSelector((state) => state.GetSupplierPerfReducer);
    // useEffect(() => {
    //     if (supplierPerfAPIResponse.type === 'SUCCESS_COMAN_ACTION') {
    //         setSupplierPerfData(supplierPerfAPIResponse);
    //     }
    // },
    //     [supplierPerfAPIResponse])

    const getCoManDataFromFilters = (value) => {
        // console.log("coMan Data", value);
        setSupplierPerfData(value.data)
        setMonthDiff(value.monthDiff)
        setLoader(value.loader);
        const appList = value.data?.apps
        if (appList && appList.length > 0) {
            const tempbuttonGroupItems = appList
                ?.filter(item => item.isActive)
                .map(item => ({
                    label: item.app,
                    onClick: () => window.open(item.url, "_blank"),
                }));

            setButtonGroupItems(tempbuttonGroupItems)
        }
    }

    // const currentSpendActual = splitNumericValue(supplierPerfData?.spendActualData?.spendActualForCurrentYear);
    // const previousSpendActual = supplierPerfData?.spendActualData?.spendActualForLastYear;
    // const spendActualPrctChange = supplierPerfData?.spendActualData?.percentage;
    // const productivityActual = splitNumericValue(supplierPerfData?.productivityActualData);
    const currentProductivity = splitNumericValue(supplierPerfData?.productivityActualData?.productivityActualForCurrentYear);
    const previousProductivity = supplierPerfData?.productivityActualData?.productivityActualForLastYear;
    const productivityPrctChange = supplierPerfData?.productivityActualData?.percentage;
    const spendActual = splitNumericValue(supplierPerfData?.spendActualData);
    // const capacityUtilization = supplierPerfData?.capacityUtilizationActualData;
    const volumeActual = splitNumericValue(supplierPerfData?.volumeActualData);
    const cpmActualData = supplierPerfData?.cpmActualData;
    const spendVsAOPData = supplierPerfData?.spendActualVsAOPData;
    const productivityVsAOPData = supplierPerfData?.productivityActualVsAOPData;
    const isEDFIntegrated = supplierPerfData?.edfintegrated;

    const capacityVsAOPData = supplierPerfData?.capacityActualVsAOPData;
    const volumeVsAOPData = supplierPerfData?.volumeActualVsAOPData;
    const cpmVsAOPData = supplierPerfData?.cpmActualVsAOPData;
    const appOwnersList = supplierPerfData?.owners
    const emailList = appOwnersList?.map(contact => contact.emailId).join(', ');

    const MODAL_TITLE = 'CoMan';

    useEffect(() => {
        if (openModal) {
            try {
                trackModalView(`${MODAL_TITLE} ${capability}`, 'view');
            } catch (error) {
                // Silent fail for tracking errors to not disrupt user experience
            }
        }
    }, [openModal, capability]);

    const handleClose = () => {
        try {
            trackModalView(`${MODAL_TITLE} ${capability}`, 'close');
        } catch (error) {
            // Silent fail for tracking errors
        }
        setOpenModal(false);
    };


    const { showToast } = useToast();

    const checkPDFDownloaded = () => {}
    

    return (
        <Modal
            onCloseModal={handleClose}
            primaryButtonProps={{
                onClick: handleClose,
                size: "medium",
                text: "Close",
                variant: "primary",
            }}
            showPrimaryButton={true}
            showLink={false}
            showSecondaryButton={false}
            showTertiaryButton={false}
            showAuxiliaryButton={false}
            showSlot={true}
            showModal={openModal}
            closeOnOutsideClick={false}
            hideCloseButton={false}
            type="XL"
            {...getModalAttributes(`${MODAL_TITLE} ${capability}`)}
        >
            <div ref={comanRef}>
                <div className="modal-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>
                        {userData?.FirstName}, Productivity across your Co-Mans is <b>{currentProductivity?.value}{currentProductivity?.suffix}</b>
                        {
                            isEDFIntegrated &&
                            <Tooltip direction="bottom" text={staticNotes.EDF_NOTE}>
                                <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible", marginBottom: "7px" }} />
                            </Tooltip>
                        }
                    </span>
                    {
                        isLoading ? (
                            <></>
                        ) :                    
                        <>
                            {/* <ButtonGroup
                                style={{ marginRight: '2rem' }}
                                className="buy-con-button-group"
                                items={buttonGroupItems}
                                size="small"
                            /> */}
                            <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <CustomButtons isModal={true} appList={supplierPerfData?.apps} />
                                {/* <button onClick={() => handleDomToImgDownloadPdf(comanRef, "Coman_Modal")}>PDF</button> */}
                                <span style={{float: 'right', position: 'relative', right: '2rem', bottom: '0.6rem'}}>
                                    <DropdownWithIcons modalRef={comanRef} kpiName={"Coman_Modal"} isModal={true} checkPDFDownloaded={checkPDFDownloaded}/>
                                </span>
                            </span>
                        </>
                    }
                </div>
                {(supplierPerfData?.lastUpdate) && <div className="modal-update-frequesncy">Data As On: {returnHyphenIfNull(supplierPerfData?.lastUpdate)} | Refresh Frequency: {returnHyphenIfNull(supplierPerfData?.refreshFrequency)}</div>}
                <ModalFilters selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} onParentCallback={getCoManDataFromFilters} landingPageFilters={landingPageFilters} setLoader={setLoader} />
                <br />
                {
                    isLoading ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                            <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                        </div>
                        :
                        <>
                            <div style={{ marginTop: 10, marginBottom: 10, display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
                                <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Card style={{ height: '100%',display:'flex' }}>
                                    <div className='header-kpi-wrapper'>
                                    {
                                        currentProductivity.value ? <>
                                            <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                <div className="spend-modal-alphanumeric-value">
                                                    <div className='spend-modal-numeric-value'>{currentProductivity.value}</div>
                                                    <div className="spend-modal-alpha-value">{currentProductivity.suffix}</div>
                                                </div>
                                                <div className='spend-modal-total-spend-text'>Productivity Actual</div>
                                            </Col>
                                        </> : ''
                                    }
                                    {
                                        previousProductivity ?
                                        <>

                                            <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>

                                                    <div className="spend-modal-last-year-value">
                                                        <span className="last-year">LY</span>
                                                        <span className="last-year-value">{previousProductivity ? previousProductivity : "N/A"}</span>
                                                    </div>

                                                    {
                                                        productivityPrctChange ?
                                                            <div className="spend-modal-percentage-value">
                                                                <span>{productivityPrctChange}</span>
                                                                <Icon
                                                                    alt="alt value"
                                                                    icon={parseFloat(productivityPrctChange) == 0 ? "" : (parseFloat(productivityPrctChange) > 0 ? "arrow_upward" : "arrow_downward")}
                                                                    size="small"
                                                                    style={{ color: '#fff', fontSize: 13 }}
                                                                />
                                                            </div> : ""
                                                    }
                                                </div>
                                            </Col>
                                        </> : ''
                                    }


                                    {
                                        spendActual ?
                                            <>
                                                <div className="modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={4} lg={4} xl={4}>

                                                    <div>
                                                        <div className="spend-modal-alphanumeric-value-small">
                                                            <div className='spend-modal-numeric-value-small'>{spendActual.value}</div>
                                                            <div className="spend-modal-alpha-value-small">{spendActual.suffix}</div>
                                                        </div>
                                                        <div className='spend-modal-manage-spend'>Spend Actual</div>
                                                    </div>
                                                </Col>
                                            </> : ''
                                    }


                                    {/* {
                                        capacityUtilization ?
                                            <>
                                                <div className="modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={3} lg={3} xl={3}>

                                                    <div>
                                                        <div className="spend-modal-total-supplier">{capacityUtilization}</div>
                                                        <div className='spend-modal-manage-spend'>Capacity Utilization Actual</div>
                                                    </div>
                                                </Col></> : ''
                                    } */}

                                    {
                                        volumeActual ?
                                            <>
                                                <div className="modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                                                    <div>

                                                        <div className="spend-modal-alphanumeric-value-small">
                                                            <div className='spend-modal-numeric-value-small'>{formatNumberWithCommas(volumeActual.value)}</div>
                                                            <div className="spend-modal-alpha-value-small">{(volumeActual.suffix).replace("KTons", "Tons (K)")}</div>
                                                        </div>
                                                        {/* <div className="spend-modal-total-supplier">{volumeActual}</div> */}
                                                        <div className='spend-modal-manage-spend'>Volume Actual</div>
                                                    </div>
                                                </Col>
                                            </> : ''
                                    }

                                    {
                                        cpmActualData ?
                                            <>
                                                <div className="modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                    <div>
                                                        <div className="spend-modal-total-supplier">{cpmActualData}</div>
                                                        <div className='spend-modal-manage-spend' style={{ display: "flex" }}>CPM Actual <InfoIcon text="Complaints Per Million" /></div>
                                                    </div>
                                                </Col>
                                            </> : ''
                                    }
                                    </div>
                                </Card>
                                </Col> 
                                </Row>
                            </div>
                            {/* <br /> */}
                            <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <div ref={spendActualvsAOPChartRef}>
                                        <Card>
                                            {
                                                spendVsAOPData?.length > 0 ?
                                                    <>
                                                        <div className='coman-chart-title'>
                                                            Spend Actual vs AOP
                                                            <span style={{float: 'right'}}>
                                                                <DropdownWithIcons checkPDFDownloaded={checkPDFDownloaded} modalRef={spendActualvsAOPChartRef} kpiName={"Spend Actual vs AOP"}/>
                                                            </span>
                                                        </div>
                                                        <CoManChart data={spendVsAOPData} xAxisLabel="Spend in $ (MN)"
                                                            xPrimaryDataKey="actualValue" xSecodaryDataKey="aopValue" yDataKey="buName"
                                                            title1={"Spend Actual"} title2={"Spend AOP"} />
                                                        {/* <Legend title1={"Spend Actual"} title2={"Spend AOP"} /> */}
                                                        <LegendList legends={[
                                                                    { name: 'Spend Actual', color: '#0078A7'},
                                                                    { name: 'Spend AOP', color:"#B05788"},
                                                        ]}/>
                                                    </> :
                                                    <NoData />
                                            }
                                        </Card>
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <div ref={productivityActualvsAOPChartRef}>
                                        <Card>
                                            {
                                                productivityVsAOPData?.length > 0 ?
                                                    <>
                                                        <div className='coman-chart-title'>
                                                            Productivity Actual vs AOP
                                                            <span style={{float: 'right'}}>
                                                                <DropdownWithIcons checkPDFDownloaded={checkPDFDownloaded} modalRef={productivityActualvsAOPChartRef} kpiName={"Productivity Actual vs AOP"}/>
                                                            </span>
                                                        </div>
                                                        <CoManChart data={productivityVsAOPData} xAxisLabel="Productivity in $ (K)"
                                                            xPrimaryDataKey="actualValue" xSecodaryDataKey="aopValue" yDataKey="buName"
                                                            title1={"Productivity Actual"} title2={"Productivity AOP"} />
                                                        {/* <Legend title1={"Productivity Actual"} title2={"Productivity AOP"} /> */}
                                                        <LegendList legends={[
                                                                    { name: 'Productivity Actual', color: '#0078A7'},
                                                                    { name: 'Productivity AOP', color:"#B05788"},
                                                        ]}/>
                                                    </> :
                                                    <NoData />
                                            }
                                        </Card>
                                    </div>
                                </Col>
                            </Row>
                            <br />
                            <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                                {/* <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                    <Card>
                                        {
                                            capacityVsAOPData?.length > 0 ?
                                                <>
                                                    <div className='coman-chart-title'>Capacity Utilization Actual vs AOP</div>
                                                    <CoManChart data={capacityVsAOPData} xAxisLabel="Capacity Utilization %"
                                                        xPrimaryDataKey="actualValue" xSecodaryDataKey="aopValue" yDataKey="buName" />
                                                    <Legend title1={"Capacity Actual"} title2={"Capacity AOP"} />
                                                </> :
                                                <NoData />
                                        }
                                    </Card>
                                </Col> */}
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <div ref={volumeActualvsAOPChartRef}>
                                        <Card>
                                            {
                                                volumeVsAOPData?.length > 0 ?
                                                    <>
                                                        <div className='coman-chart-title'>
                                                            Volume Actual vs AOP
                                                            <span style={{float: 'right'}}>
                                                                <DropdownWithIcons checkPDFDownloaded={checkPDFDownloaded} modalRef={volumeActualvsAOPChartRef} kpiName={"Volume Actual vs AOP"}/>
                                                            </span>
                                                        </div>
                                                        <CoManChart data={volumeVsAOPData} xAxisLabel="Volume in Tons (K)"
                                                            xPrimaryDataKey="actualValue" xSecodaryDataKey="aopValue" yDataKey="buName"
                                                            title1={"Volume Actual"} title2={"Volume AOP"} />
                                                        {/* <Legend title1={"Volume Actual"} title2={"Volume AOP"} /> */}
                                                        <LegendList legends={[
                                                                    { name: 'Volume Actual', color: '#0078A7'},
                                                                    { name: 'Volume AOP', color:"#B05788"},
                                                        ]}/>
                                                    </> :
                                                    <NoData />
                                            }
                                        </Card>
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <div ref={complaintsActualvsAOPChartRef}>
                                        <Card>
                                            {
                                                cpmVsAOPData?.length > 0 ?
                                                    <>
                                                        <div className='coman-chart-title'>
                                                            Complaints per Million Actual vs AOP
                                                            <span style={{float: 'right'}}>
                                                                <DropdownWithIcons checkPDFDownloaded={checkPDFDownloaded} modalRef={complaintsActualvsAOPChartRef} kpiName={"Complaints per Million Actual vs AOP"}/>
                                                            </span>
                                                        </div>
                                                        <CoManChart data={cpmVsAOPData} xAxisLabel="Complaints Per Million"
                                                            xPrimaryDataKey="actualValue" xSecodaryDataKey="aopValue" yDataKey="buName"
                                                            title1={"Complaints per Million Actual"} title2={"Complaints per Million AOP"} />
                                                        {/* <Legend title1={"Complaints per Million Actual"} title2={"Complaints per Million AOP"} /> */}
                                                        <LegendList legends={[
                                                                    { name: 'Complaints per Million Actual', color: '#0078A7'},
                                                                    { name: 'Complaints per Million AOP', color:"#B05788"},
                                                        ]}/>
                                                    </> :
                                                    <NoData />
                                            }
                                        </Card>
                                    </div>
                                </Col>
                            </Row>
                            <br />

                            <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                                {
                                    appOwnersList?.length > 0 &&
                                    <div style={{width: '100%'}}>Please reach out to {appOwnersList?.map((contact, index) => (
                                        <React.Fragment key={index}>
                                            <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                            {index < appOwnersList.length - 1 && ', '}
                                        </React.Fragment>
                                    ))} for any query on the data displayed.</div>
                                }
                                <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                            </div>
                        </>
                }
                <br/>
            </div>
        </Modal>
    )
}

export default ComanModal